module.exports = __webpack_public_path__ + "img/belgium-external-causes-female.6a562ae2.png";